import { Copy } from 'lucide-react';
import { Button } from './ui';
import { useToast } from './toast';

export default function CopyButton({ value, label = 'Copier' }: { value: string; label?: string }) {
  const toast = useToast();

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(value);
      toast.success('Copié dans le presse-papiers');
    } catch {
      toast.push('info', 'Copie impossible : sélectionnez le texte manuellement');
    }
  };

  return (
    <Button size="sm" onClick={copy} aria-label={`${label} ${value}`}>
      <Copy size={14} aria-hidden />
      {label}
    </Button>
  );
}
